import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import config from "../config/config";

export const displayErrorString = (error) => {
  toast.configure({
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  toast.error(error);
}
export const displayError = (error) => {
  toast.configure({
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  if (error.response.status === 422) {
    var row = [];
    Object.keys(error.response.data.errors).forEach((key, i) => {
      row.push(error.response.data.errors[key][0]);
    })
    const Msg = ({ closeToast, toastProps }) => (
      row.map((char, i) => {
        var res = char.replace(/\./g, '')
        return (
          <li>
            {res}
          </li>
        );
      })
    )
    toast.error(Msg);
  } else if (error.response.status === 400 || error.response.status === 401) {
    toast.error((error.response.data.message));
  } else {
    toast.error((error.message));
  }
}
export const displaySuccess = (success) => {
  toast.configure({
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  toast.success(success);
}


export const fileUpload = async () => {
  let path = config.siteUrl;
  // var token = localStorage.getItem('token');
  var result = await axios.get(path + "/classes/upload", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getRegularClasses = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + "/classes/get-regular-classes", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}


export const getFlexClasses = async () => {
  let path = config.siteUrl;
  // var token = localStorage.getItem('token');
  var result = await axios.get(path + "/classes/get-flex-classes", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getArchivedData = async () => {
  let path = config.siteUrl;
  // var token = localStorage.getItem('token');
  var result = await axios.get(path + "/classes/get-archive-data", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}


export const getAllTimezones = async () => {
  let path = config.siteUrl;
  // var token = localStorage.getItem('token');
  var result = await axios.get(path + "/common/get-timezones", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const formatTime = (from, to) => {
  var fromTime = ''
  var toTime = ''
  if (from !== null) {
    if (from !== undefined) {
      if (from?.length == 3) {
        fromTime = '0' + from.slice(0, 1) + ':' + from.slice(-2)
      } else {
        fromTime = from.slice(0, 2) + ':' + from.slice(-2)
      }
    } else {
      fromTime = ''
    }
  } else {
    fromTime = ''
  }
  if (to !== null) {
    if (to !== undefined) {
      if (to.length == 3) {
        toTime = '0' + to.slice(0, 1) + ':' + to.slice(-2)
      } else {
        toTime = to.slice(0, 2) + ':' + to.slice(-2)
      }
    } else {
      toTime = ''
    }
  } else {
    toTime = ''
  }
  var final = fromTime + ' - ' + toTime
  return final
}

export const formatFromTime = (from) => {
  var fromTime = ''
  if (from !== null) {
    if (from !== undefined) {
      if (from?.length == 3) {
        fromTime = '0' + from.slice(0, 1) + ':' + from.slice(-2)
      } else {
        fromTime = from.slice(0, 2) + ':' + from.slice(-2)
      }
    } else {
      fromTime = ''
    }
  } else {
    fromTime = ''
  }
  var final = fromTime
  return final
}
export const formaToTime = (to) => {
  var toTime = ''

  if (to !== null) {
    if (to !== undefined) {
      if (to.length == 3) {
        toTime = '0' + to.slice(0, 1) + ':' + to.slice(-2)
      } else {
        toTime = to.slice(0, 2) + ':' + to.slice(-2)
      }
    } else {
      toTime = ''
    }
  } else {
    toTime = ''
  }
  var final = toTime
  return final
}
export const statusText = (id) => {
  if (id == '1') {
    return "Raw data"
  } else if (id == '2') {
    return 'Grouped data with instructor accepted'
  } else if (id == '3') {
    return 'Pending Instructor acceptance'
  } else if (id == '4') {
    return 'Pending Instructor'
  } else if (id == '5') {
    return 'Pending'
  } else if (id == 6) {
    return 'Signed'
  } else if (id == 7) {
    return 'Rejected'
  } else if (id == 8) {
    return 'Expired'
  } else if (id == 9) {
    return 'Sou downloaded'
  } else if (id == 10) {
    return 'First sou reminder'
  } else if (id == 11) {
    return 'Second sou reminder'
  } else {
    return 'class created'
  }
}


export const authMe = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  // console.log(token, "token url");

  var response_final = await axios.get(`${path}/common/authme`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': `${token}`
    }
  })
    .then(function (response) {
      // console.log(response, "response authMe data.....");
      if (response?.data?.status === 401) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_data");
        window.location.href = "/";
      }
      return response.data.data;
    })
    .catch(function (error) {
      console.error("authMe error:", error);
      
      return null;
    });

  return response_final;
}



export const userLoggedIn = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var response_final = await axios.get(path + "/common/authme", {
    headers: { 'Content-Type': 'application/json', Authorization: ` ${token}`, 'Accept': 'application/json' },
  })
    .then(function (response) {
      // console.log(response,"userLogedIn data.....")
      return response.data.data;
    })
    .catch(function (error) {
      // if (error.response.status === 401) {
      //   window.location.href = '/'
      // }
      // else {
      return null
      // }
    });
  return response_final;
}

export const getLanguage = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + "/common/get-languages", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data.data
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const getInstructorList = async (lang_id, course_id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/common/get-instructors?language_id=${lang_id}`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data.data
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const getInstructorDetails = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/common/get-instructor-details/${id}?language_id=${lang}`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getInstructorDetailsWithSchedule = async (id, lang, schedule, class_number, start_date) => {
  var token = localStorage.getItem('access_token');
  let path = config.siteUrl;
  var result = await axios.post(path + '/common/get-instructor-details-schedule', {
    id: id,
    language_id: lang,
    schedule: schedule,
    class_number: class_number,
    start_date: start_date
  }, {
    headers: { 'content-Type': 'application/json', Authorization: `${token}` },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error)
    });
  return result;
}

export const processDataApi = async (request) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  // console.log(token)
  var response_final = await axios.post(path + "/classes/process-raw-data-new", {
    request
  }, {
    headers: { 'Accept': 'Application/json', 'Authorization': `${token}` },
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      return null;
    });
  return response_final;
}

export const getGroupedList = async (request) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  // console.log(token)
  var response_final = await axios.post(path + "/classes/get-group-by-status", {
    status: request
  }, {
    headers: { 'Accept': 'Application/json', 'Authorization': `${token}` },
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    });
  return response_final;
}
export const getClassesList = async (request) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  // console.log(token)
  var response_final = await axios.post(path + "/classes/get-classes-by-status", {
    status: request
  }, {
    headers: { 'Accept': 'Application/json', 'Authorization': `${token}` },
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    });
  return response_final;
}
export const createClasses = async (request) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  // console.log(token)
  var response_final = await axios.post(path + "/processes/create-class", {
    id: request
  }, {
    headers: { 'Accept': 'Application/json', 'Authorization': `${token}` },
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    });
  return response_final;
}
export const getCreatedClassList = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/created-class-list`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getSouList = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/get-sou-list`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const getClassCreatedList = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/created-class-list`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const exportAllSou = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/export-sou-data`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const exportExpiredAllSou = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/export-expired-sou-data`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}
export const exportClassCreated = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/export-created-classes`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}


export const getArchiveData = async (id, lang) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.get(path + `/classes/get-archive-data`, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getSouData = async (hash) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.post(path + `/processes/view-sou`, {
    generated_hash: hash
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getPendingData = async (hash) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.post(path + `/classes/view-instructor-request`, {
    generated_hash: hash
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getHolidayData = async (id, lang) => {
  let path = config.siteUrl;
  var result = await axios.get(`${path}/common/get-holiday`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return null;
    });
  return result;
};

export const getTrainingData = async () => {
  let path = config.siteUrl;
  var result = await axios.get(path + "/classes/get-training-list", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const gettrainerList = async () => {
  let path = config.siteUrl;
  var result = await axios.get(path + "/common/get-trainers", {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

export const getTrainerData = async (hash, status) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('access_token');
  var result = await axios.post(path + `/classes/process-training-status`, {
    generated_hash: hash,
    training_status: status
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return null
    });
  return result;
}

